import { MutationStatus } from 'react-query'
import { InlineAlert, Loader } from 'components'
import { CustomAxiosError } from 'utils/api'

type QueryStatusAlertProps = {
  queryStatus: MutationStatus
  isLoading?: boolean
  successMsg?: string
  errorTitle?: string
  errorObj?: CustomAxiosError | null
  errorMsg?: string
  show404Error?: boolean
  loaderChild?: React.ReactNode
  autoScrollToAlert?: boolean
}

export const QueryStatusAlert = (props: QueryStatusAlertProps) => {
  const {
    queryStatus,
    isLoading,
    successMsg,
    errorTitle,
    errorObj,
    errorMsg,
    show404Error,
    loaderChild,
    autoScrollToAlert,
  } = props

  return (
    <>
      {(isLoading || (!isLoading && queryStatus === 'loading')) && <Loader customChild={loaderChild} />}
      {queryStatus === 'success' && successMsg && (
        <InlineAlert message={successMsg} autoScrollToAlert={autoScrollToAlert} />
      )}
      {queryStatus === 'error' && (show404Error || errorObj?.errorCode !== 404) && (
        <InlineAlert
          severity="error"
          message={`${errorTitle ?? ''} ${errorMsg ?? errorObj?.errorMessage ?? 'Network Error!'}`}
          autoScrollToAlert={autoScrollToAlert}
        />
      )}
    </>
  )
}
